@if (failed()) {
  <error-page />
} @else {
  <ng-content />
}
